export function escapeHtml(s: string): string {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function viewBackButton(label = "← Back"): string {
  return `<button type="button" class="view-back secondary" data-action="back">${escapeHtml(label)}</button>`;
}
